import {
  animate,
  type AnimationOptions,
  type DOMKeyframesDefinition,
} from 'motion/react';

type PlayFlipArgs = {
  node: HTMLElement;
  keyframes: DOMKeyframesDefinition;
  options?: AnimationOptions;
  onSettle?: (node: HTMLElement) => void;
  onDone?: () => void;
};

export function playFlip({
  node,
  keyframes,
  options,
  onSettle,
  onDone,
}: PlayFlipArgs) {
  const controls = animate(node, keyframes, options);
  let settled = false;
  controls.finished.then(
    () => {
      settled = true;
      onSettle?.(node);
      onDone?.();
    },
    () => undefined,
  );
  return () => {
    controls.stop();
    if (!settled) onSettle?.(node);
  };
}
